export enum EImportJobStatus {
  AWAITING = "AWAITING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
  CANCELED = "CANCELED",
  ERROR = "ERROR"
}
